import React, { PureComponent } from 'react'
import * as R from 'ramda'
import PartnerLoader from 'components/Loaders/PartnerLoader/index.tsx'
import { LoaderWrapper } from './style'

// type Props = {
//   load: () => Promise<*>,
//   Loader: () => Element<*>
// }

// type State = { component: ComponentType<*> | null }

export default class Chunk extends PureComponent {
  static defaultProps = { Loader: PartnerLoader }

  constructor (props) {
    super(props)

    this.state = { component: null }
    this.load()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.load !== this.props.load) { this.load() }
  }

  load = () => {
    const { component } = this.state

    if (component) { this.setState({ component: null }) }

    this.props.load()
      .then(component => {
        this.setState({ component: component.default || component })
      })
  }

  render () {
    const Component = this.state.component
    const { Loader } = this.props
    const componentProps = R.omit(['styles', 'Loader'], this.props)

    return (
      <Choose>
        <When condition={Component}>
          <Component {...componentProps} />
        </When>
        <When condition={Loader}>
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>
        </When>
      </Choose>
    )
  }
}
